// Only known catalogue labels are corrected for display. Raw option values and
// source descriptions stay unchanged, so filters still address the original data.
const groupLabels: Record<string, string> = {
  'Ara�� bilgileri': 'Araç bilgileri',
  'Dı�� Trim': 'Dış Trim',
  'D��ş Trim': 'Dış Trim',
  'G��vde': 'Gövde',
  'G��ç Paketi': 'Güç Paketi',
  'Iç Trim': 'İç Trim',
  'I�� Trim': 'İç Trim',
  'Yür��r Aksam': 'Yürür Aksam',
  'Y��rür Aksam': 'Yürür Aksam',
};
export function displayStudyGroup(value: string): string {
  return groupLabels[value] || (value.includes('\uFFFD') ? 'Grup adı okunamıyor' : value) || 'Grup belirtilmemiş';
}
export function studyDay(value: string): string {
  return new Date(value + 'T12:00:00+03:00').toLocaleDateString('tr-TR', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Istanbul'
  });
}
